import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import TrezorConnect, { UI_EVENT } from 'trezor-connect'

import Icon from '../../common/Icon'
import Button from '../../common/Button'
import { withI18n } from '../../../i18n/util'
import { FootRow } from './UnlockFromKeystore'
import { Title } from './UnlockWalletConnect'

import errorIcon from '../../../static/images/error-icon.svg'

export const TREZOR_BIP44_PATH = "m/44'/714'/0'/0/0"

const Wrapper = styled.div`
  width: 100%;
  color: #48515d;
  position: relative;
  padding-bottom: 40px;
`

const Row = styled.div`
  margin: 25px 0;
  font-size: 14px;
`

const ErrorMsg = styled.div`
  color: #f23051;
  font-size: 14px;
  display: flex;
  align-items: center;
  img {
    flex: 0 0 auto;
    width: 15px;
    margin-right: 5px;
  }
`

const TrezorLogo = styled.div`
  align-items: center;
  margin: -20px auto 0px auto;
  overflow: hidden;
  height: 130px;
  display: flex;
  width: 55%;

  > img {
    opacity: 0.8;
    width: 100%;
  }
`

const TrezorFirmwareNotice = styled.p`
  margin-bottom: 30px;
`

class UnlockFromTrezor extends PureComponent {
  static propTypes = {
    unlock: PropTypes.func,
    formatI18nText: PropTypes.func.isRequired,
  }

  static defaultProps = {
    unlock: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      errored: false,
      errMsg: '',
    }
    TrezorConnect.on(UI_EVENT, ev => {
      console.info('Trezor Event!', ev)
    })
  }

  _unlock = () => {
    const { unlock } = this.props
    this.setState({ loading: true })
    setTimeout(async () => {
      try {
        const {
          payload: { address },
        } = await TrezorConnect.binanceGetAddress({
          path: TREZOR_BIP44_PATH,
        })

        this.setState(
          {
            loading: false,
            errored: false,
          },
          () => {
            // success - redirects to /trade
            unlock('HARDWARE', address, '', '', { isHardware: true, isTrezor: true })
          }
        )
      } catch (err) {
        console.error('Trezor Connect error', err)
        this.setState({
          loading: false,
          errored: true,
          errMsg: err.message,
        })
      }
    }, 0)
  }

  render() {
    const { formatI18nText } = this.props
    const { loading, errored, errMsg } = this.state
    return (
      <Wrapper>
        <Title>
          <p className="recommend">{formatI18nText('unlock.trezor.title')}</p>
          <p className="notes">
            <i />
            {formatI18nText('unlock.trezor.notOnTestNet')}
          </p>
        </Title>

        <TrezorLogo>
          <img
            alt="Trezor Logo"
            src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJsb2dvdHlwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMTYzLjcgNDEuOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTYzLjcgNDEuOTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cG9seWdvbiBwb2ludHM9IjEwMS4xLDEyLjggMTE4LjIsMTIuOCAxMTguMiwxNy4zIDEwOC45LDI5LjkgMTE4LjIsMjkuOSAxMTguMiwzNS4yIDEwMS4xLDM1LjIgMTAxLjEsMzAuNyAxMTAuNCwxOC4xIDEwMS4xLDE4LjEgCgkiLz4KPHBhdGggZD0iTTE1OC44LDI2LjljMi4xLTAuOCw0LjMtMi45LDQuMy02LjZjMC00LjUtMy4xLTcuNC03LjctNy40aC0xMC41djIyLjNoNS44di03LjVoMi4ybDQuMSw3LjVoNi43TDE1OC44LDI2Ljl6IE0xNTQuNywyMi41CgloLTRWMThoNGMxLjUsMCwyLjUsMC45LDIuNSwyLjJDMTU3LjIsMjEuNiwxNTYuMiwyMi41LDE1NC43LDIyLjV6Ii8+CjxwYXRoIGQ9Ik0xMzAuOCwxMi41Yy02LjgsMC0xMS42LDQuOS0xMS42LDExLjVzNC45LDExLjUsMTEuNiwxMS41czExLjctNC45LDExLjctMTEuNVMxMzcuNiwxMi41LDEzMC44LDEyLjV6IE0xMzAuOCwzMC4zCgljLTMuNCwwLTUuNy0yLjYtNS43LTYuM2MwLTMuOCwyLjMtNi4zLDUuNy02LjNjMy40LDAsNS44LDIuNiw1LjgsNi4zQzEzNi42LDI3LjcsMTM0LjIsMzAuMywxMzAuOCwzMC4zeiIvPgo8cG9seWdvbiBwb2ludHM9IjgyLjEsMTIuOCA5OC4zLDEyLjggOTguMywxOCA4Ny45LDE4IDg3LjksMjEuMyA5OCwyMS4zIDk4LDI2LjQgODcuOSwyNi40IDg3LjksMzAgOTguMywzMCA5OC4zLDM1LjIgODIuMSwzNS4yICIvPgo8cGF0aCBkPSJNMjQuNiw5LjdDMjQuNiw0LjQsMjAsMCwxNC40LDBTNC4yLDQuNCw0LjIsOS43djMuMUgwdjIyLjNoMGwxNC40LDYuN2wxNC40LTYuN2gwVjEyLjloLTQuMlY5Ljd6IE05LjQsOS43CgljMC0yLjUsMi4yLTQuNSw1LTQuNXM1LDIsNSw0LjV2My4xSDkuNFY5Ljd6IE0yMywzMS41bC04LjYsNGwtOC42LTRWMTguMUgyM1YzMS41eiIvPgo8cGF0aCBkPSJNNzkuNCwyMC4zYzAtNC41LTMuMS03LjQtNy43LTcuNEg2MS4ydjIyLjNINjd2LTcuNWgyLjJsNC4xLDcuNUg4MGwtNC45LTguM0M3Ny4yLDI2LjEsNzkuNCwyNCw3OS40LDIwLjN6IE03MSwyMi41aC00VjE4CgloNGMxLjUsMCwyLjUsMC45LDIuNSwyLjJDNzMuNSwyMS42LDcyLjUsMjIuNSw3MSwyMi41eiIvPgo8cG9seWdvbiBwb2ludHM9IjQwLjUsMTIuOCA1OC42LDEyLjggNTguNiwxOC4xIDUyLjQsMTguMSA1Mi40LDM1LjIgNDYuNiwzNS4yIDQ2LjYsMTguMSA0MC41LDE4LjEgIi8+Cjwvc3ZnPgo="
          />
        </TrezorLogo>

        <TrezorFirmwareNotice>
          {formatI18nText('unlock.trezor.firmwareNotice')}
        </TrezorFirmwareNotice>

        {errored && (
          <Row>
            <ErrorMsg>
              <img src={errorIcon} alt="" />
              <span>{errMsg}</span>
            </ErrorMsg>
          </Row>
        )}

        <FootRow>
          <div />
          <Button loading={loading} onClick={this._unlock} width="170px" className="unlock">
            <Fragment>
              <span
                style={{
                  marginRight: '10px',
                }}
              >
                {formatI18nText('unlock.trezor.connectToTrezor')}
              </span>
              <Icon type="continue" size="20" color="inherit" />
            </Fragment>
          </Button>
        </FootRow>
      </Wrapper>
    )
  }
}

export default withI18n(UnlockFromTrezor)
